import type {
  DataTagMetadata,
  DataTagSummary,
} from '@robovision/data'


export interface TagParams {
  attributes: Record<string, string>
  createdAt: Date
  description?: string
  name: string
  ownerId?: string
  poolId: string
  sampleCount?: number
  slug: string
  tagId: string
}

export class Tag {
  public readonly attributes: Record<string, string>
  public readonly createdAt: Date
  public readonly description?: string
  public readonly name: string
  public readonly ownerId?: string
  public readonly poolId: string
  public sampleCount?: number
  public readonly slug: string
  public readonly tagId: string

  constructor (params: TagParams) {
    this.attributes = params.attributes
    this.createdAt = params.createdAt
    this.description = params.description
    this.name = params.name
    this.ownerId = params.ownerId
    this.poolId = params.poolId
    this.sampleCount = params.sampleCount
    this.slug = params.slug
    this.tagId = params.tagId
  }

  public get mutable () {
    // we should get this as a constant from the BE somehow
    // attributes.jobType is old nomenclature, but still supported for existing
    // imports
    return this.attributes?.jobType !== 'IMPORT' && this.attributes?.tagType !== 'IMPORT' && this.attributes?.tagType !== 'RECORDING'
  }

  public get isTemporary () {
    return !this.ownerId && !this.poolId
  }

  public static fromResponse (data: DataTagSummary | DataTagMetadata) {
    return new Tag({
      attributes: data.attributes,
      createdAt: new Date(data.createdAt),
      description: data.description,
      name: data.name,
      ownerId: data.ownerId,
      poolId: data.poolId,
      sampleCount: 'sampleCount' in data ? data.sampleCount : undefined,
      slug: data.slug,
      tagId: data.tagId,
    })
  }
}
